import React from "react";

function Brand() {
  return (
    <div className="first-section">
      <h1>Built to last, Cook with Confidence</h1>
      <p>
        Limited edition! Get yours before they are gone again, shop the
        collection now!
      </p>
    </div>
  );
}

export default Brand;
